import { render, staticRenderFns } from "./AddCampaignForm4.vue?vue&type=template&id=511c16f6&"
import script from "./AddCampaignForm4.vue?vue&type=script&lang=js&"
export * from "./AddCampaignForm4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports